import { FileType, CommonType } from '../api-types';

export type IPostThumbnails = FileType;

export type IPostAuthorPicture = FileType;
export interface IPostDocType extends FileType {
  postId: string;
  title: string;
  fileName: string;
}

export enum PostType {
  PLATFORM = 'PLATFORM',
  CONTENT = 'CONTENT',
  GENERAL = 'GENERAL',
  COMPETITIONS = 'COMPETITIONS',
  WEBINARS = 'WEBINARS',
  ALLPOSTS = 'ALLPOSTS',
}

export type PostCategoryCountType = {
  [PostType.ALLPOSTS]: number;
  [PostType.COMPETITIONS]: number;
  [PostType.CONTENT]: number;
  [PostType.GENERAL]: number;
  [PostType.PLATFORM]: number;
  [PostType.WEBINARS]: number;
};

export interface IPostAuthor extends CommonType {
  firstName: string;
  lastName: string;
  bio: string;
  userId: string;
  authorImage: IPostAuthorPicture;
}
